import { defineRule } from 'vee-validate';

defineRule('passwordRule', (value) => {
  if (!value || !value.length) {
    return 'password-missing';
  }

  // ^(?=.*\d) = match at least 1 digit
  // (?=.*[A-Z]) = AND match at least 1 uppercase
  // .{6,20} = AND given data must be 6-20 characters long 
  if (!/^(?=.*\d)(?=.*[A-Z]).{6,20}/.test(value)) {
    return 'password-invalid';
  }

  return true
});

defineRule('emailRule', (value) => {
  if (!value || !value.length) {
    return true // Allow empty email
  }

  // Must include @ and . with content preceding and succeeding
  if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/.test(value)) {
    return 'email-invalid';
  }

  return true
});